import React, { useEffect, useState } from 'react'
import { useSelector,useDispatch } from 'react-redux';
import { ExternalVendor } from './ExternalVendor';
import { InternalVendor } from './InternalVendor';
import { MachineTranslation } from './MachineTranslation';
import { MultiVendors } from './MultiVendors';
import { updateProjectInfo } from '../../redux/reducers/ProjectInfoSlice';
import { useTranslation } from 'react-i18next';
import { externalVendorIcon, internalVendorIcon, machineTranslationIcon, multiVendorIcon } from '../../AppIcons';
import { ConditionalBlock } from '../../ConditionalBlock';
import { TranslationTypeCard } from './TranslationTypeCard';

import APIUrls from '../../services/APIUrls';
import { dateConvertToTimeStamp } from '../../services/Util';
import { getAxiosResponse, handleError } from '../../services/authApiRoutes/APImethods';
import { useParams } from 'react-router-dom';
import Constants from '../../Constants';

export const ProjectTranslate = () => {

	const dispatch = new useDispatch();
	const { t } = useTranslation();
	const translate = t;

	const params = useParams();

	const [internalTranslators, setInternalTranslators] = useState(false);
	const [machineTranslationEngines, setMachineTranslationEngines] = useState(false);
	const [machineTranslationAccess, setMachineTranslationAccess] = useState(false);
	const [allFilesMachineTranslatable, setAllFilesMachineTranslatable] = useState(false);

	const projectData = useSelector(
		(reduxStore) => reduxStore.project_info
	  ).value;

	const customerBootstrapData = useSelector(
	(reduxStore) => reduxStore.customer_bootstrap_data
	).value;

	useEffect(() => {
		getInternalTranslatorVendor(projectData?.userGroup?.id);
		getCustomerPreference();
		getMachineTranslationEngines();
		getAllFilesMachineTranslatable();
	}, [])

	const getInternalTranslatorVendor = async (depId) => {
		const dateTimestamp = dateConvertToTimeStamp();
		const result = await getAxiosResponse(APIUrls.INTERNAL_TRANSALATOR(depId) + `?_=${dateTimestamp}`)
		if(result?.data?.data?.length > 0){
			setInternalTranslators(true);
		}
	}

	const getCustomerPreference = () => {
		const dateTimestamp = dateConvertToTimeStamp();
		getAxiosResponse(
		  APIUrls.CUSTOMER_ORG_PREFERENCE + `?preference=ENABLE_MACHINE_TRANSLATION&_=${dateTimestamp}`
		).then((res) => {
		  if (res?.data?.code === 200) {
			setMachineTranslationAccess(res?.data?.data?.status === Constants.TRUE)
		  }
		}).catch((err) => {
		  handleError(err);
		});
	}

	const getMachineTranslationEngines = async () => {
		const dateTimestamp = dateConvertToTimeStamp();
		const result = await getAxiosResponse(APIUrls.MACHINE_TRANSLATION(params.id) + `?_=${dateTimestamp}`)
		if(result.data.data && result?.data?.data?.length > 0) {
			setMachineTranslationEngines(true);
		}
	}

	const getAllFilesMachineTranslatable = async () => {
		const dateTimestamp = dateConvertToTimeStamp();
		const result = await getAxiosResponse(APIUrls.PROJECT_FILES_MACHINE_TRANSLATABLE(params.id) + `?_=${dateTimestamp}`);
		setAllFilesMachineTranslatable(result?.data?.data?.value);
	}

	const isMachineTranslationAvailable = () => {
		const { features, permissions } = customerBootstrapData || {};
		if (features?.MACHINE_TRANSLATION && 
			(machineTranslationAccess && permissions?.MACHINE_TRANSLATION_ACCESS || machineTranslationEngines)) {
			return allFilesMachineTranslatable;
		}
		return false;
	}

	const dispatchFinalDataToRedux = (type, value) => {		
        dispatch(updateProjectInfo({
            type: type,
            value: value
        }));
	}

	const onCardSelect = (translationType)=>{
	    dispatchFinalDataToRedux('translationType',translationType);
	    if(translationType === 'MULTI_VENDOR'){
	        dispatchFinalDataToRedux('projectVendorType','EXTERNAL');
	    }else{
	    	dispatchFinalDataToRedux('projectVendorType',translationType);
	        dispatchFinalDataToRedux('translationPreferences',[]);
	    }
	}

	const isMultiVendorProject = (projectData?.targetLanguages?.length > 1 && (projectData?.translationType ==='MULTI_VENDOR' || projectData?.translationPreferences?.length > 1));
	useEffect(() => {
        if(isMultiVendorProject){
            dispatchFinalDataToRedux('translationType','MULTI_VENDOR');
        }else{
            dispatchFinalDataToRedux('translationPreferences',[]);
        }
    },[]);

  return (
		<>
                <div  className="translate-project">
					<div className="project-heading mar-bot25">
						<h3> {translate("project_listing.who_translate") }</h3>
						<label>{translate("project_listing.click_option")}</label>
					</div>
					<div  className="translate-box flex" role="tablist">
                        <TranslationTypeCard
                            label = "External Vendor"
                            icon = {externalVendorIcon}
                            type = {'EXTERNAL'}
                            selected = {!isMultiVendorProject && (projectData?.projectVendorType==='EXTERNAL'  || projectData?.projectVendorType==='EXTERNAL_BIDLESS')}
                            onCardSelect = {onCardSelect}
					    />

                        <ConditionalBlock condition={(customerBootstrapData?.features?.INTERNAL_TRANSLATORS && internalTranslators)}>
                            <TranslationTypeCard
                                label = "Internal Translator"
                                icon = {internalVendorIcon}
                                type = {'INTERNAL'}
                                selected = {(projectData?.projectVendorType==='INTERNAL')}
                                onCardSelect = {onCardSelect}
                            />
					    </ConditionalBlock>

                        <ConditionalBlock condition={(isMachineTranslationAvailable())}>
                            <TranslationTypeCard
                                label = "Machine Translation"
                                icon = {machineTranslationIcon}
                                type = {'MACHINE_TRANSLATION'}
                                selected = {(projectData?.projectVendorType==='MACHINE_TRANSLATION')}
                                onCardSelect = {onCardSelect}
                            />
					    </ConditionalBlock>

                        <ConditionalBlock condition={(projectData?.targetLanguages?.length > 1)}>
                            <TranslationTypeCard
                                label = "Multi Vendors"
                                icon = {multiVendorIcon}
                                type = {'MULTI_VENDOR'}
                                selected = {isMultiVendorProject}
                                onCardSelect = {onCardSelect}
                            />
					    </ConditionalBlock>

					</div>
				</div>

                <ConditionalBlock condition={!isMultiVendorProject && (projectData?.projectVendorType==='EXTERNAL'  || projectData?.projectVendorType==='EXTERNAL_BIDLESS')}>
                    <ExternalVendor/>
                </ConditionalBlock>

                <ConditionalBlock condition={(projectData?.projectVendorType==='INTERNAL')}>
                    <InternalVendor/>
                </ConditionalBlock>

                <ConditionalBlock condition={(projectData?.projectVendorType==='MACHINE_TRANSLATION')}>
                    <MachineTranslation/>
                </ConditionalBlock>

                <ConditionalBlock condition={isMultiVendorProject}>
                    <MultiVendors/>
                </ConditionalBlock>

			 </>
 
   )
}
